import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function HierarchyFilesIcon({
  className,
  height = 12,
  stroke = '#146EE8',
  width = 12,
}: SimpleIconInterface) {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      viewBoxDimensions="0 0 12 12"
      width={width}
    >
      <path d="M1.2525 4.74951V5.99951" />
      <path d="M1.2525 7.24951V8.49951" />
      <path d="M1.2525 2.75V3.25C1.2525 3.38261 1.30518 3.50979 1.39895 3.60355C1.49272 3.69732 1.61989 3.75 1.7525 3.75H2.2525" />
      <path d="M1.2525 9.75V10.25C1.2525 10.3826 1.30518 10.5098 1.39895 10.6036C1.49272 10.6973 1.61989 10.75 1.7525 10.75H2.2525" />
      <path d="M3.5 3.74951H5" />
      <path d="M3.5 10.7495H5" />
      <path d="M1.2525 0.249512V1.49951" />
      <path d="M10.25 4.75C10.25 4.88261 10.1973 5.00979 10.1036 5.10355C10.0098 5.19732 9.88261 5.25 9.75 5.25H6.75C6.61739 5.25 6.49021 5.19732 6.39645 5.10355C6.30268 5.00979 6.25 4.88261 6.25 4.75V0.75C6.25 0.617392 6.30268 0.490215 6.39645 0.396447C6.49021 0.302678 6.61739 0.25 6.75 0.25H8.25C8.56646 0.267161 8.86758 0.391876 9.1035 0.6035L9.8965 1.3965C10.1081 1.63242 10.2328 1.93354 10.25 2.25V4.75Z" />
      <path d="M8.5 0.284668V1.50017C8.5 1.63278 8.55268 1.75995 8.64645 1.85372C8.74021 1.94749 8.86739 2.00017 9 2.00017H10.2145" />
      <path d="M10.25 11.25C10.25 11.3826 10.1973 11.5098 10.1036 11.6036C10.0098 11.6973 9.88261 11.75 9.75 11.75H6.75C6.61739 11.75 6.49021 11.6973 6.39645 11.6036C6.30268 11.5098 6.25 11.3826 6.25 11.25V7.25C6.25 7.11739 6.30268 6.99021 6.39645 6.89645C6.49021 6.80268 6.61739 6.75 6.75 6.75H8.307C8.44751 6.75 8.58664 6.77769 8.71644 6.83148C8.84625 6.88527 8.96418 6.96411 9.0635 7.0635L9.8965 7.8965C10.1081 8.13242 10.2328 8.43354 10.25 8.75V11.25Z" />
      <path d="M8.5 6.76807V8.00007C8.5 8.13267 8.55268 8.25985 8.64645 8.35362C8.74021 8.44739 8.86739 8.50007 9 8.50007H10.215" />
    </SimpleIcon>
  );
}
